import { useEffect, useState } from "react";
import ApiHome from "../../core/api/api.home";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { Card } from "@mui/material";
import SplitNumber from "./_Components/SplitNumber";
import {
  IconTicket1,
  IconCoinBags,
  IconWallet,
  IconTicketReceipt,
} from "../../_metronic/css/icons";

export function DashboardPage() {
  const [dashboardData, setDashboardData] = useState({});
  const [loadingData, setLoadingData] = useState(false);
  useEffect(() => {
    (async () => {
      setLoadingData(true);
      try {
        const data = await ApiHome.getSupplierDashboard();
        setDashboardData(data.data);
        setLoadingData(false);
      } catch (error) {
        setLoadingData(false);
      } finally {
      }
    })();
    return () => { };
  }, []);

  return (
    <>
      <Row>
        <Col xs="12">
          <div
            className=" text-secondary rounded-2 p-5 bg-white  mb-5"
            style={{ borderRight: "5px solid #3699ff" }}
          >
            <span className="fw-bold">
              {" "}
              {dashboardData?.supplierCompanyName}{" "}
            </span>
            به پنل تامین کنندگان خوش آمدید.
          </div>
        </Col>
      </Row>

      <Row>
        <Col md="4" className="mb-4 mb-md-0">
          <Card className="bg-primary text-white rounded-4">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <IconWallet className="opacity-75" width="40" />
                <h4 className="fw-bold mt-4 me-3">کیف پول</h4>
              </div>

              <div className="mt-5 pb-5 mb-3 d-flex align-items-center">
                <IconCoinBags width="18px" className="ms-1" />
                <div className=" mx-1">موجودی</div>

                {loadingData ? (
                  <div
                    className="opacity-75 mx-1"
                    style={{ lineHeight: "26px" }}
                  >
                    در حال دریافت اطلاعات
                  </div>
                ) : (
                  <>
                    <div className="fw-bold fs-large mx-1">
                      <SplitNumber number={dashboardData?.walletAmount} />
                    </div>
                    تومان
                  </>
                )}
              </div>
              <Link
                to="/supllierWithdrawals"
                className="btn btn-outline-white py-2 bg-light-transparent"
              >
                {/* <IconPlus width="18px" className="ms-1" /> */}
                درخواست برداشت وجه
              </Link>
            </div>
          </Card>
        </Col>
        {/* <Col md="4" className="mb-4 mb-md-0">
        <Card className="bg-info text-white h-100 rounded-4">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <IconTicketFill className="opacity-75 " width="40px" />

              <h4 className="fw-bold mt-4 me-3"> بلیط های آماده استفاده </h4>
            </div>

            <div className="mt-5 pb-5 mb-3 d-flex align-items-center">
              <IconTicket1
                width="18px"
                className="ms-2 "
                style={{ marginTop: "-2px" }}
              />
              <div>تعداد</div>
              {loadingData ? (
                <div className="opacity-75 mx-1" style={{ lineHeight: "26px" }}>
                  در حال دریافت اطلاعات
                </div>
              ) : (
                <>
                  <div className="fw-bold fs-large mx-1">
                    {dashboardData?.readyToUseTicketsCount}{" "}
                  </div>
                  بلیط{" "}
                </>
              )}
            </div>
            <Link
              to="/ticketSearch"
              className="btn btn-outline-white py-2  bg-light-transparent"
            >
              جست و جو و ابطال{" "}
            </Link>
          </div>
        </Card>
      </Col> */}
        <Col md="4" className="mb-4 mb-md-0">
          <Card className="bg-success text-white h-100 rounded-4">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <IconTicketReceipt className="opacity-75" width="40px" />
                <h4 className="fw-bold mt-4 me-3">
                  {" "}
                  بلیط های ابطال شده امروز{" "}
                </h4>
              </div>

              <div className="mt-5 pb-5 mb-3 d-flex align-items-center">
                <IconTicket1
                  width="18px"
                  className="ms-2"
                  style={{ marginTop: "-2px" }}
                />
                <div>تعداد</div>

                {loadingData ? (
                  <div
                    className="opacity-75 mx-1"
                    style={{ lineHeight: "26px" }}
                  >
                    در حال دریافت اطلاعات
                  </div>
                ) : (
                  <>
                    <div className="fw-bold fs-large mx-1">
                      {dashboardData?.todayUsedTicketsCount}
                    </div>
                    بلیط
                  </>
                )}
              </div>
              <Link
                to="/ticketList"
                className="btn btn-outline-white py-2 bg-light-transparent"
              >
                مشاهده لیست بلیط ها
              </Link>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
}
